import React, { useState } from "react";
import { XIcon } from "lucide-react";
import { useCreateChatRequestMutation } from "../../../../redux/service/customerServices";
import { toast } from "sonner";

const JoinActivityDialog = ({
  activityName,
  onSubmit,
  onClose,
  activityId,
}) => {
  const userId = localStorage.getItem("user_id");
  const [createChatRequest, createChatRequestInfo] =
    useCreateChatRequestMutation();

  const [message, setMessage] = useState("");
 
  const handleSubmit = async () => {
     const formatedData = {
      activity: activityId,
      from_user: userId,
      initial_message: message || "I am interested in this activity.",
      is_accepted: false,
    };
    try {
      const response = await createChatRequest(formatedData).unwrap();

      console.log('Chat request sent:', response);
      localStorage.setItem('from_user_name', response.from_user_name);
      toast.success(
        'Your interest request has been sent. Waiting for the Activity Admin to accept.'
      );
    //   setIsChatBoxOpen(false);
    //   setChatMessage('');
    //   await fetchAllChatRequestsForActivity();
    } catch (error) {
      console.error('Failed to send chat request:', error);
      if (error?.data?.message) {
        toast.error(`Failed to send interest request: ${error.data.message}`);
      } else {
        toast.error('Failed to send interest request. Please try again.');
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-900">
            Join {activityName}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <XIcon className="h-6 w-6" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">
              Message to Organizer
            </label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Introduce yourself and explain why you'd like to join this activity..."
              required
            />
          </div>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600"
            >
               {createChatRequestInfo?.info ?  'loading...' : 'Send Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default JoinActivityDialog;
